import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
`;

export const IconContainer = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  position: relative;
`;

export const TextInfo = styled.span`
  display: flex;
  line-height: 28px;
  max-width: 310px;
  min-height: 24px;
  word-break: break-word;
`;
